import http from "@http"

//列表  分页
export function getWaveFormList(data) {
    return http({
        url: '/lskj-document/api/document/waveForm/list',
        method: "post",
        data
    })
}
// 列表 不分页
export function getWaveFormAll(data) {
    return http({
        url: '/lskj-document/api/document/waveForm/all',
        method: "post",
        data
    })
}

//查询单条信息
export function waveFormById(data) {
    return http({
        url: `/lskj-document/api/document/waveForm/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function waveFormAdd(data) {
    return http({
        url: '/lskj-document/api/document/waveForm/add',
        method: "post",
        data
    })
}

//修改
export function updeteWaveForm(data) {
    return http({
        url: `/lskj-document/api/document/waveForm`,
        method: "put",
        data
    })
}
//删除
export function deleteWaveForm(data) {
    return http({
        url: `/lskj-document/api/document/waveForm?ids=${data.ids}`,
        method: "delete",
        data
    })
}


//线路树（线路区站）
export function getCircuitTree(data) {
    return http({
        url: '/lskj-data/api/data/circuit/tree',
        method: "post",
        data
    })
}

//查询单条信息
export function waveFormOpen(data) {
    return http({
        url: `/lskj-document/api/document/waveForm/open?filePath=${data.filePath}`,
        method: "get",
    })
}